module.exports = __webpack_public_path__ + "media/images/flags/32/Taiwan-f870b5a1cfb63922d7eb495dea3643e4.png";